<template>
  <div class="tab-bar-layout">
    <!-- <TabHeader :routeName="$route.name" /> -->
    <slot />
    <TabBar :tabs="tabs" />
  </div>
</template>

<script>
  // import TabHeader from '@/components/TabHeader.vue';
  import TabBar from '@/components/TabBar.vue';
  import { getInstance } from '@/plugins/auth0/use-auth0';

  export default {
    name: 'tab-bar-layout',
    components: {
      // TabHeader,
      TabBar,
    },
    data() {
      return {
        defaultTabs: [
          {
            icon: 'chart-line',
            label: 'Balance',
            routeName: 'balance',
          },
          {
            icon: 'store',
            label: 'Stations',
            routeName: 'stations',
          },
          {
            icon: 'coins',
            label: 'Earn',
            routeName: 'earn',
          },
          {
            icon: 'tags',
            label: 'Offers',
            routeName: 'offers',
          },
        ],
        roleTabs: [],
        lastTabs: [
          {
            icon: 'cog',
            label: 'Settings',
            routeName: 'settings',
          },
        ],
      };
    },
    computed: {
      tabs() {
        return [...this.defaultTabs, ...this.roleTabs, ...this.lastTabs];
      },
    },
    async mounted() {
      const authService = getInstance();
      const { flattenedOrganizationRoles } = await authService.getUserRoles();
      if (flattenedOrganizationRoles.operator) {
        this.roleTabs.push({
          icon: 'qrcode',
          label: 'Operator',
          routeName: 'operator',
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .tab-bar-layout {
    display: flex;
    flex-direction: column;
  }
</style>
